import { BooksSubscriptionContent } from "pages/Books/BooksDashboard/BooksSubscriptionModalContent";
import Modal from "./DesignSystem/Modal/Modal";
import { useGetSubscriptionsQuery } from "store/apis/subscriptions";
import { BOOKS_PLUS_PLAN } from "constants/subscriptionType";
import { useEffect, useState } from "react";
import { Subscription } from "types/Models/subscription";
import Async from "./DesignSystem/AsyncComponents/Async";
import { useDispatch } from "react-redux";
import { setAddonData, setAddonType } from "store/slices/addons";
import { _MANAGE } from "constants/addons";
import { CheckoutModal } from "./CheckoutModal/CheckoutModal";
import { useModal } from "hooks/useModal";

export type BooksSoftwareSubscriptionsModalProps = {
  open: boolean;
  onClose: () => void;
  entityId?: string;
  onProductSubscribe?: () => void;
};

export const BooksSoftwareSubscriptionsModal = ({
  open,
  onClose,
  entityId,
  onProductSubscribe,
}: BooksSoftwareSubscriptionsModalProps) => {
  const {
    data: subscriptionPlans,
    isLoading,
    isSuccess,
  } = useGetSubscriptionsQuery({
    subscription_types: BOOKS_PLUS_PLAN,
  });
  const dispatch = useDispatch();
  const checkoutModal = useModal();

  const softwareStandardActivePlan = subscriptionPlans?.find(
    (item) =>
      item?.subscription_type === BOOKS_PLUS_PLAN &&
      item?.group_subscription?.length
  );
  const [selectedPlan, setSelectedPlan] = useState<Subscription | undefined>();

  const softwareStandardBillingCycle =
    selectedPlan?.billing_cycle! === "MONTHLY" ? "month" : "year";

  const softwareStandardAmount = selectedPlan?.amount! || 30;

  const softwareStandardButtonText = softwareStandardActivePlan
    ? "Manage Subscription"
    : "Upgrade to Standard";

  const softwareStandardButtonType = softwareStandardActivePlan
    ? "secondary"
    : "primary-outlined";
  const onManage = () => {
    dispatch(setAddonData(selectedPlan));
    dispatch(setAddonType(selectedPlan?.subscription_type + _MANAGE));
  };

  const onSubscribed = () => {
    onProductSubscribe?.();
    checkoutModal.close();
  };

  useEffect(() => {
    subscriptionPlans?.at(0) && setSelectedPlan(subscriptionPlans?.at(0));
  }, [subscriptionPlans]);
  return (
    <Modal.Root open={open} onOpenChange={onClose}>
      <Modal.Content size="large">
        <Modal.Header>
          <Modal.Title>Upgrade Your Plan</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <Async.Root
            isEmpty={
              !subscriptionPlans ||
              subscriptionPlans.length === 0 ||
              selectedPlan?.metadata?.comparison?.length === 0
            }
            isLoading={isLoading}
            isSuccess={isSuccess}
          >
            <Async.Success>
              <section>
                <BooksSubscriptionContent
                  price={softwareStandardAmount}
                  softwareStandardActivePlan={softwareStandardActivePlan}
                  selectedPlan={selectedPlan}
                  billingCycle={softwareStandardBillingCycle}
                  buttonType={softwareStandardButtonType}
                  buttonText={softwareStandardButtonText}
                  onManage={onManage}
                  subscriptionPlans={subscriptionPlans!}
                  setSelectedPlan={setSelectedPlan}
                  checkoutModal={checkoutModal}
                  toggleValue={selectedPlan?.uuid}
                />
                <CheckoutModal
                  entityId={entityId}
                  type="subscription"
                  onClose={checkoutModal.close}
                  open={checkoutModal.isOpen}
                  subscription={selectedPlan!}
                  onSubscribed={onSubscribed}
                />
              </section>
            </Async.Success>
          </Async.Root>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
